import type { LoaderFunctionArgs } from 'react-router';
import { useLoaderData } from 'react-router';

import { MENU_CONTEXT } from '@jane/bloom/middlewares/menuContext.server';
import { getEmailSession } from '@jane/bloom/sessions/email.server';
import type { RouteHandle } from '@jane/bloom/types/schemas/bloom/routeHandle';

import { ForgotPassword } from './components/forgotPassword';

export const handle: RouteHandle = {
  hydrate: true,
};

export async function loader({ context, request }: LoaderFunctionArgs) {
  const { menu } = context.get(MENU_CONTEXT);
  const { getSession } = getEmailSession(menu.cookie_prefix);
  const emailSession = await getSession(request.headers.get('Cookie'));
  const userEmail = emailSession.get('email')?.email;

  return {
    userEmail,
  };
}

export default function ForgotPasswordRoute() {
  const { userEmail } = useLoaderData<typeof loader>();

  return <>{userEmail && <ForgotPassword userEmail={userEmail} />}</>;
}
